import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { ConfigContext } from "../../../../../../../services/Config/context";
import { SupportAccessOrganizationApplicationLogApi } from "../../../../../../../services/support/types";

interface Props {
	historyAccess: SupportAccessOrganizationApplicationLogApi[];
}

const SupportAccessHistoryTable = ({ historyAccess }: Props) => {
	const { t } = useTranslation();
	const configService = useContext(ConfigContext);

	const drawApplicationCellContent = (item: SupportAccessOrganizationApplicationLogApi) => {
		const appUrl = configService.getRedirectUrl(item.type, item.organization_company_id);
		return (
			<a target="_blank" href={appUrl} rel="noreferrer">
				{t(`enums.apps.application_type.${item.type}`, { ns: "admin" })}
			</a>
		);
	};

	return (
		<div className="mt-3 mb-3">
			<hr />
			<h5>{t("modules.service_access.field.history_table.title")}</h5>
			<div className="table-responsive">
				<table className="table table-preview">
					<thead>
						<tr>
							<th>{t("lib:common.word.created_at")}</th>
							<th>{t("lib:common.word.email")}</th>
							<th>{t("modules.service_access.field.app.title")}</th>
							<th>{t("modules.service_access.field.support_access_to.title")}</th>
							<th>{t("modules.service_access.field.permissions.title")}</th>
						</tr>
					</thead>
					<tbody>
						{historyAccess
							.filter((_, index) => index < 20)
							.map((item, index) => (
								<tr key={`history-access-row-${index}`}>
									<td>{FormatDate(item.created_at)}</td>
									<td>{item.user_email}</td>
									<td>{drawApplicationCellContent(item)}</td>
									<td>{FormatDate(item.support_access_to)}</td>
									<td>
										{item.permissions
											.map((permission) => t(`enums.support_permissions.${permission}`))
											.join(", ")}
									</td>
								</tr>
							))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default SupportAccessHistoryTable;

// t(`enums.support_permissions.SALE`);
// t(`enums.support_permissions.CONFIGURATION`);
